import {
  CreateButton, DatagridConfigurable,
  DeleteButton,
  EditButton, FilterButton,
  List,
  NumberField, NumberInput, SelectColumnsButton,
  ShowButton,
  TextField, TextInput, TopToolbar,
  useTranslate, WrapperField,
} from "react-admin";

import { Rules } from "../../types/rules";
import StringArray from "../common/StringArray";

const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <FilterButton/>
    <CreateButton/>
  </TopToolbar>
);

const rulesFilters = [
  <TextInput label="Name" source="name" alwaysOn={true}/>,
  <NumberInput label="Threshold" source="threshold" />,
  <TextInput label="Currency Code" source="currencyCode" />,
  <NumberInput label="Rate" source="rate" alwaysOn={true} />,
  <TextInput label="Countries From" source="countriesFrom" />,
  <TextInput label="Countries To" source="countriesTo" />,
  <TextInput label="Sellers Label" source="sellersLabel" />,
  <TextInput label="States To" source="statesTo" />,
  <TextInput label="Made in countries" source="madeInCountries" />
];

const RulesList = () => {
  const translate = useTranslate();

  return (
    <List
      actions={<ListActions/>} filters={rulesFilters}
      sort={{ field: "id", order: "DESC" }}
      title={translate("rules.list.title")}
      sx={{
        mt: 1,
        "& .RaList-actions": {
          mb: 1,
        },
      }}
    >
      <DatagridConfigurable bulkActionButtons={false} rowClick="show">
        <TextField<Rules> source="_id" />
        <TextField<Rules> source="name" />
        <NumberField<Rules> source="rate" label="Rate" />
        <NumberField<Rules> source="threshold" label="Threshold" />
        <TextField<Rules> source="currencyCode" label="currencyCode" />
        <StringArray<Rules> fieldName="countriesFrom" label="Countries From" />
        <StringArray<Rules> fieldName="countriesTo" label="Countries To" />
        <StringArray<Rules> fieldName="sellersLabel" label="Sellers Label" />
        <StringArray<Rules> fieldName="statesTo" label="States To" />
        <StringArray<Rules> fieldName="madeInCountries" label="Made In Coutries" />
        <WrapperField label="Actions">
          <ShowButton />
          <EditButton />
          <DeleteButton mutationMode="pessimistic" />
        </WrapperField>
        {/* To delete the record with a confirmation dialog */}
      </DatagridConfigurable>
    </List>
  );
};

export default RulesList;
